// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint import/first: 0 */
import Vue from 'vue';
import AWS from 'aws-sdk';
import Amplify, { Hub } from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import Resource from 'vue-resource';
import VueLogger from 'vuejs-logger';
import VeeValidate, { Validator } from 'vee-validate';
import VuePaginate from '@/modules/paginate';
import VueBreadcrumbs from 'vue-breadcrumbs';
import tld from '@/validators/tld';
import capitalize from '@/filters/capitalize';
import truncate from '@/filters/truncate';
import { lightning } from '@/proxy/lightning';
import { onFirstDrop } from '@/mixins/first-drop';
import { searchParty } from '@/mixins/search-party';
import { drzUtils } from '@/mixins/utils';
import { awsUtils } from '@/mixins/aws-utils';
import amplifyConfig from '@/mixins/aws/amplify';
import { Tooltip, Tabs, Nestable, DropletBubbles, Dragula } from '@/directives/main';
import App from './global-view';
import router from './router';
import store from './store';

import 'cropperjs/dist/cropper.css';
import 'vue-select/dist/vue-select.css';
import '@/less/main.less';

// load in our picazzo js dependencies if picazzo isn't running locally or on builds
if (process.env.IMPORT_PICAZZO || process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging') {
  require('@nm/picazzo/dist/js/modules/jquery-2.2.4.min.js');
  require('@nm/picazzo/dist/js/modules/jquery.mobile.custom.min.js');
  require('@nm/picazzo/dist/js/picazzo.droplet.lib.min.js');
}

const isProd = process.env.NODE_ENV === 'production' && process.env.ADMIN !== 'storm';

Amplify.configure({ Auth: amplifyConfig });

Validator.extend('tld', tld);
Vue.filter('capitalize', capitalize);
Vue.filter('truncate', truncate);
Vue.use(Resource);
Vue.use(VuePaginate);
Vue.use(VeeValidate, { fieldsBagName: 'vv-fields' });
Vue.use(VueBreadcrumbs);
Vue.mixin(awsUtils);
Vue.mixin(onFirstDrop);
Vue.mixin(searchParty);
Vue.mixin(drzUtils);
Vue.use(Tooltip);
Vue.use(Tabs);
Vue.use(Nestable);
Vue.use(DropletBubbles);
Vue.use(Dragula);

Vue.use(VueLogger, {
  isEnabled: !isProd,
  logLevels: ['debug', 'info', 'warn', 'error', 'fatal'],
  stringifyArguments: false,
  showLogLevel: false,
  showMethodName: false,
  showConsoleColors: true,
});

AWS.config.correctClockSkew = true;
Vue.prototype.$aws = AWS;
Vue.prototype.$amplify = Amplify;
Vue.prototype.$amplify.Auth = Auth;
Vue.prototype.$amplify.Hub = Hub;
Vue.prototype.$lightning = lightning;
Vue.prototype.$env = process.env.NODE_ENV;
Vue.prototype.$demo = process.env.DEMO;
Vue.config.productionTip = false;
Vue.config.devtools = !isProd;
Vue.config.performance = true;
Vue.config.debug = true;

/* eslint-disable no-new */
new Vue({
  el: '#drzzle',
  name: 'drzzle',
  router,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js